export default "__VITE_ASSET__BCuSDKiA__"